import $ from 'jquery';

$(document).ready(function () {
  acfSubHeroBlock();
});

function acfSubHeroBlock() {
  $('.js-acf-sub-hero-block').each(function () {});
}
